import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Button = styled(PrimaryButton)`
  width: 100px;
  padding: 0.5rem 1rem;
  font-size: 12px !important;
`;

export const DivEditar = styled.div`
  display: flex;
  justify-content: space-between;
`;
